import React from 'react'

export const AppFooter = () => {
  return (
    <footer className="p-3 text-center">
      <p className="text-white">
        <span className="text-white text-opacity-70">Created by Gevorg Harutyunyan</span>{' '}
        [{' '}
        <a href="https://github.com/modularcoder" className="underline">
          @modularcoder
        </a>{' '}
        ]
      </p>
    </footer>
  )
}

export default AppFooter
